import { makeStyles, css } from '@conexasaude/conexa-hero'
// import noise from '@/assets/noise.png'

const useStyles = makeStyles({
  boxLogoConexa: ({ colors }) => css`
    width: 100%;
    padding: 24px;
    border-bottom: 1px solid ${colors.neutral[100]};
    background-color: ${colors.background.white};
    padding-bottom: 20px;
    img {
      height: 20px;
    }
  `,
})

export { useStyles }
